import React, { ReactElement } from "react";

interface Props {
  renderTopPageImageSlider: () => ReactElement<any>;
}

export const DesktopSmallTopPageImageSliderTemplate = (props: Props) => {
  return <>{props.renderTopPageImageSlider()}</>;
};
